<template>
  <div>
    <Group v-if="templateType === 'group'"/>
    <Manage v-if="templateType === 'manage'"/>
  </div>
</template>

<script>
import Content from '@/components/Content';
import Group from './group';
import Manage from './manage';

export default {
  components: {
    Content, Manage, Group,
  },
  computed: {
    templateType() {
      return this.$store.state.storeManage.templateType;
    },
  },
  methods: {
    async initPrimaryReq(pageNum = 1) {
      this.currPage = pageNum;
      this.$store.dispatch('storeManage/fetchStoreAll', {});
      this.$store.dispatch('storeManage/fetchProvinceAll');
      this.$store.dispatch('storeManage/fetchFormatAll');
    },
  },
  created() {
    this.initPrimaryReq();
  },
};
</script>

<style>

</style>
